import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';

import { VpHoverInfo } from '../';

const statusToDetailsMapper = {
  DONE: {
    text: 'Done',
    color: 'success',
    info: 'Your video has been transcribed to text successfully. If there is any audio on the recording, the corresponding text will be displayed below.'
  },
  STARTED: {
    text: 'Started',
    color: 'warning',
    info: 'We are working on transcribing the video’s audio to text for you. Please check back in a few minutes!'
  },
  'NOT STARTED': {
    text: 'Not Started',
    color: 'info',
    info: `We did not start transcribing your video to text yet, please check back in a few seconds. Please note that past submissions are not transcribed when upgrading.`
  }
};

export const VpTranscriptionBadge = ({ transcriptionStatus = 'NOT STARTED' }) => {
  const badgeDetails =
    statusToDetailsMapper[transcriptionStatus] || statusToDetailsMapper['NOT STARTED'];

  return (
    <VpHoverInfo label={badgeDetails?.info}>
      <Chip color={badgeDetails?.color} label={badgeDetails?.text} />
    </VpHoverInfo>
  );
};

VpTranscriptionBadge.propTypes = {
  transcriptionStatus: PropTypes.string
};

export default VpTranscriptionBadge;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpTranscriptionBadge/VpTranscriptionBadge.jsx